import { useMutation } from "@tanstack/react-query";
import { journalsServiceApi } from "@/entities/api";

type BuildSignLineParams = {
  sectionTwoListId?: string;
  sectionListId?: string;
  itemNoVersionId: string;
  signerEmployeeId: string;
};

const buildSignLine = async (params: BuildSignLineParams) => {
  const sectionTwoListId = params.sectionTwoListId || params.sectionListId || "";
  const { itemNoVersionId, signerEmployeeId } = params;
  const token = localStorage.getItem("token");

  const response = await journalsServiceApi.post(
    `/journals/section-two/${sectionTwoListId}/items/${itemNoVersionId}/sign`,
    { signerEmployeeId },
    {
      responseType: "text",
      headers: {
        "X-Auth": token || "",
      },
    },
  );

  return response.data;
};

export const useBuildSignLine = () => {
  return useMutation<string, Error, BuildSignLineParams>({
    mutationFn: buildSignLine,
  });
};

